module.exports = __webpack_public_path__ + "0768e808a979383c720cb4b5de0182ee.png";